import {
  saveNewCustomerData,
  saveEditedCustomerData,
  setIsLoadingOnCustomerProfile
} from "../../actions/customerProfile";
import { updateGlobalErrorMessage } from "../../actions/globalError";
import { forceValidation } from "./validMeReact";

export function saveCustomerDataHandler(
  customerProfileData,
  apiCustomerProfileData,
  dispatch,
  cb
) {
  const areThereErrors = forceValidation(
    null,
    null,
    "customerProfileNames&customerProfileContacts"
  );

  let { ErrorPhoneCannotBeDeletedInThisPage } = window.APP.LANGUAGE.Errors;
  let { ErrorEmailCannotBeDeletedInThisPage } = window.APP.LANGUAGE.Errors;

  let address = null;
  let city = null;
  let state = null;
  let postalcode = null;
  if (
    customerProfileData.address.address1 &&
    customerProfileData.address.address1.length > 0
  ) {
    address = customerProfileData.address.address1;
  }
  if (
    customerProfileData.address.city &&
    customerProfileData.address.city.length > 0
  ) {
    city = customerProfileData.address.city;
  }
  if (
    customerProfileData.address.state &&
    customerProfileData.address.state.length > 0
  ) {
    state = customerProfileData.address.state;
  }
  if (
    customerProfileData.address.postalcode &&
    customerProfileData.address.postalcode.length > 0
  ) {
    postalcode = customerProfileData.address.postalcode;
  }

  if (!areThereErrors) {
    dispatch(setIsLoadingOnCustomerProfile(true));
    let payload = {
      firstname: "",
      lastname: "",
      emails: [],
      phonenumbers: [],
      address: {
        address1: address,
        city: city,
        state: state,
        postalcode: postalcode
      },
      blocked: customerProfileData.blocked,
      capturecreditcard: customerProfileData.captureCreditCard
    };

    let { firstName, lastName } = customerProfileData;
    firstName = firstName ? firstName.capitalizeFirstLetter() : "";
    lastName = lastName ? lastName.capitalizeFirstLetter() : "";

    if (apiCustomerProfileData.id) {
      // for edit, keep the old data for the firstname, lastname, email, and phone. Update those using the booking. To avoid having to replicate the backend logic in the frontend.
      payload.firstname = firstName;
      payload.lastname = lastName;

      let shouldContinue = true;

      // email logic
      let addedEmail = false;
      let primaryEmail = null;

      if (
        apiCustomerProfileData.emails &&
        apiCustomerProfileData.emails.find(x => x.primary)
      ) {
        primaryEmail = apiCustomerProfileData.emails.find(x => x.primary).email;
      }
      if (
        customerProfileData.email.length > 0 &&
        customerProfileData.email != primaryEmail
      ) {
        payload.emails.push({
          email: customerProfileData.email,
          primary: true
        });
        addedEmail = true;
      }

      apiCustomerProfileData.emails.map(email => {
        let overridePrimaryEmail = email.primary;
        if (addedEmail) {
          overridePrimaryEmail = false;
        }
        updateGlobalErrorMessage;
        if (customerProfileData.email == "" && email.primary) {
          //this means we deleted the primary
          dispatch(
            updateGlobalErrorMessage({
              message: ErrorEmailCannotBeDeletedInThisPage
            })
          );
          shouldContinue = false;
        } else {
          payload.emails.push({
            id: email.id,
            email: email.email,
            primary: overridePrimaryEmail
          });
        }
      });

      // phone logic
      let addedPhone = false;
      let primaryPhone = null;
      if (
        apiCustomerProfileData.phonenumbers &&
        apiCustomerProfileData.phonenumbers.find(x => x.primary)
      ) {
        primaryPhone = apiCustomerProfileData.phonenumbers.find(x => x.primary)
          .number;
      }
      if (
        customerProfileData.phoneNumber.length > 0 &&
        customerProfileData.phoneNumber != primaryPhone
      ) {
        payload.phonenumbers.push({
          number: customerProfileData.phoneNumber,
          primary: true
        });
        addedPhone = true;
      }

      apiCustomerProfileData.phonenumbers.map(phone => {
        let overridePrimaryPhone = phone.primary;
        if (addedPhone) {
          overridePrimaryPhone = false;
        }
        if (customerProfileData.phoneNumber == "" && phone.primary) {
          //this means we deleted the primary
          dispatch(
            updateGlobalErrorMessage({
              message: ErrorPhoneCannotBeDeletedInThisPage
            })
          );
          shouldContinue = false;
        } else {
          payload.phonenumbers.push({
            id: phone.id,
            number: phone.number,
            primary: overridePrimaryPhone
          });
        }
      });

      if (shouldContinue) {
        payload.cb = cb;
        dispatch(saveEditedCustomerData(payload, apiCustomerProfileData.id));
      }
    } else {
      // Create new customer
      if (firstName.length > 0) {
        payload.firstname = firstName;
      }
      if (lastName.length > 0) {
        payload.lastname = lastName;
      }
      if (customerProfileData.email.length > 0) {
        payload.emails.push({
          email: customerProfileData.email,
          primary: true
        });
      }
      if (customerProfileData.phoneNumber.length > 0) {
        payload.phonenumbers.push({
          number: customerProfileData.phoneNumber,
          primary: true
        });
      }

      payload.cb = cb;
      dispatch(saveNewCustomerData(payload));
    }
  }
}
